

<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'"
                                  [moduleManager]="moduleManager"
                                  inside="date">
    <div class="custom-setting-section-inside-body">
        <div class="form-check d-flex font-size-12 mb-2 align-items-center">
            <input class="form-check-input" type="checkbox" [(ngModel)]="BreakdownMode" [attr.id]="moduleManager.getModuleKey() + '_breakdownEnabled'">
            <label class="form-check-label ml-2 mt-1" [attr.for]="moduleManager.getModuleKey() + '_breakdownEnabled'">
                <span cvLocalizedText langSection="Interval_Module" langKey="Include_Breakdown">Include Breakdown (Table View)</span>
            </label>
        </div>
        <div class="d-flex mb-2 align-items-center" *ngIf="BreakdownMode">
            <span style="padding-right: 12px;" cvLocalizedText langSection="Interval_Module" langKey="List_Data_By">List data by:</span>
            <div class="form-check" style="padding-right: 12px;">
                <input class="form-check-input" type="radio" [attr.name]="moduleManager.getModuleKey() + 'ListByInterval'" [value]="false" [(ngModel)]="ListByInterval" [attr.id]="moduleManager.getModuleKey() + '_breakdownGroup'"/>
                <label class="form-check-label" for="groupMode" cvLocalizedText langSection="Interval_Module" langKey="Groups" [attr.for]="moduleManager.getModuleKey() + '_breakdownGroup'">
                    Groups
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" [attr.name]="moduleManager.getModuleKey() + 'ListByInterval'" [value]="true" [(ngModel)]="ListByInterval" [attr.id]="moduleManager.getModuleKey() + '_breakdownInterval'"/>
                <label class="form-check-label" for="dateMode" cvLocalizedText langSection="Interval_Module" langKey="Intervals" [attr.for]="moduleManager.getModuleKey() + '_breakdownInterval'">
                    Intervals
                </label>
            </div>
        </div>
    </div>
</cv-module-custom-setting-section>

<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal' && !moduleManager.moduleSettings.hideDatePicker">
    <div cvModuleCxoneCustomSettingSection after="date" [moduleManager]="moduleManager" class="mt-1 mb-4">
        <div class="form-check d-flex font-size-12 mb-2">
            <input class="form-check-input" type="checkbox" [(ngModel)]="BreakdownMode" [attr.id]="moduleManager.getModuleKey() + '_breakdownEnabled'">
            <label class="form-check-label ml-2" [style.margin-top]="'1px'" [attr.for]="moduleManager.getModuleKey() + '_breakdownEnabled'">
                <span cvLocalizedText langSection="Interval_Module" langKey="Include_Breakdown_Table_Only">Include Breakdown</span>
            </label>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="moduleManager.settingsView === 'modal'">
    <div cvModuleLegacyCustomSettingSection [moduleManager]="moduleManager">
        <div class="gridItemSettingsPanelCustomSettingsAboveGroupSelector">
            <div class="sgCustomCheckbox customSettingCheckbox">
                <input class="sgCustomCheckbox" type="checkbox" [(ngModel)]="BreakdownMode" />
                <span class="inlineLabel" cvLocalizedText langSection="Interval_Module" langKey="Include_Breakdown">Include Breakdown (Table View)</span>
            </div>
        </div>
        <div class="d-flex mb-2 align-items-center" *ngIf="BreakdownMode">
            <span style="padding-right: 12px;" cvLocalizedText langSection="Interval_Module" langKey="List_Data_By">List data by:</span>
            <div class="form-check" style="padding-right: 12px;">
                <input class="form-check-input" type="radio" [attr.name]="moduleManager.getModuleKey() + 'ListByInterval'" [value]="false" [(ngModel)]="ListByInterval" [attr.id]="moduleManager.getModuleKey() + '_breakdownGroup'" />
                <label class="form-check-label" for="groupMode" cvLocalizedText langSection="Interval_Module" langKey="Groups" [attr.for]="moduleManager.getModuleKey() + '_breakdownGroup'">
                    Groups
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" [attr.name]="moduleManager.getModuleKey() + 'ListByInterval'" [value]="true" [(ngModel)]="ListByInterval" [attr.id]="moduleManager.getModuleKey() + '_breakdownInterval'" />
                <label class="form-check-label" for="dateMode" cvLocalizedText langSection="Interval_Module" langKey="Intervals" [attr.for]="moduleManager.getModuleKey() + '_breakdownInterval'">
                    Intervals
                </label>
            </div>
        </div>
    </div>
</ng-container>
